export const NavaAppSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، CRM ابری، خط تلفن اینترنتی، پنل پیامکی و فکس آنلاین.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-91691000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/dedicated-application/#webpage",
      "url": "https://navatel.ir/products/dedicated-application/",
      "name": "اپلیکیشن موبایل نواتل؛ خط ثابت سازمانی روی موبایل شما | دانلود رایگان",
      "description": "اپلیکیشن اختصاصی نواتل، خط ثابت سازمانی، CRM، پنل پیامکی، چت‌آنلاین و فکس را روی موبایل، تبلت و کامپیوتر شما در دسترس قرار می‌دهد. دانلود رایگان برای اندروید، iOS و ویندوز.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": [
        { "@id": "https://navatel.ir/products/dedicated-application/#software-windows" },
        { "@id": "https://navatel.ir/products/dedicated-application/#software-android" },
        { "@id": "https://navatel.ir/products/dedicated-application/#software-ios" },
        { "@id": "https://navatel.ir/products/dedicated-application/#software-linux" },
        { "@id": "https://navatel.ir/products/dedicated-application/#software-web" }
      ],
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/dedicated-application/#breadcrumb"
      }
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/dedicated-application/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "اپلیکیشن اختصاصی",
          "item": "https://navatel.ir/products/dedicated-application/"
        }
      ]
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://navatel.ir/products/dedicated-application/#software-windows",
      "name": "اپلیکیشن اختصاصی نواتل - نسخه ویندوز",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "سافت‌فون سازمانی (Softphone / Unified Communications)",
      "operatingSystem": "Windows",
      "description": "نسخه ویندوز اپلیکیشن اختصاصی نواتل برای مدیریت خط ثابت سازمانی، تماس صوتی و تصویری، CRM، پنل پیامکی، چت آنلاین سایت و فکس از طریق کامپیوتر.",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "downloadUrl": "https://dl.navatel.ir/Navatel.msi",
      "installUrl": "https://dl.navatel.ir/Navatel.msi",
      "inLanguage": "fa-IR",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "IRR",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://navatel.ir/products/dedicated-application/#software-android",
      "name": "اپلیکیشن اختصاصی نواتل - نسخه اندروید",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "سافت‌فون سازمانی (Softphone / Unified Communications)",
      "operatingSystem": "Android",
      "description": "نسخه اندروید اپلیکیشن اختصاصی نواتل برای مدیریت خط ثابت سازمانی، تماس صوتی و تصویری، CRM، پنل پیامکی، چت آنلاین سایت و فکس از طریق موبایل و تبلت.",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "downloadUrl": "https://dl.navatel.ir/Navatel.apk",
      "installUrl": "https://dl.navatel.ir/Navatel.apk",
      "inLanguage": "fa-IR",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "IRR",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://navatel.ir/products/dedicated-application/#software-linux",
      "name": "اپلیکیشن اختصاصی نواتل - نسخه لینوکس",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "سافت‌فون سازمانی (Softphone / Unified Communications)",
      "operatingSystem": "Linux",
      "description": "نسخه لینوکس اپلیکیشن اختصاصی نواتل برای مدیریت خط ثابت سازمانی، تماس صوتی و تصویری، CRM، پنل پیامکی، چت آنلاین سایت و فکس از طریق کامپیوتر.",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "downloadUrl": "https://dl.navatel.ir/navatel.deb",
      "installUrl": "https://dl.navatel.ir/navatel.deb",
      "fileFormat": "application/vnd.debian.binary-package",
      "inLanguage": "fa-IR",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "IRR",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://navatel.ir/products/dedicated-application/#software-ios",
      "name": "اپلیکیشن اختصاصی نواتل - نسخه iOS",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "سافت‌فون سازمانی (Softphone / Unified Communications)",
      "operatingSystem": "iOS",
      "description": "نسخه iOS اپلیکیشن اختصاصی نواتل برای مدیریت خط ثابت سازمانی، تماس صوتی و تصویری، CRM، پنل پیامکی، چت آنلاین سایت و فکس از طریق آیفون و آیپد. این نسخه از طریق مارکت‌های اختصاصی iOS ایرانی توزیع می‌شود.",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "downloadUrl": "https://sibapp.com/applications/Navatel",
      "installUrl": "https://sibapp.com/applications/Navatel",
      "sameAs": [
        "https://anardoni.com/ios/app/comariasamanehkarma"
      ],
      "inLanguage": "fa-IR",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "IRR",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@type": "WebApplication",
      "@id": "https://navatel.ir/products/dedicated-application/#software-web",
      "name": "اپلیکیشن اختصاصی نواتل - نسخه وب",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "سافت‌فون سازمانی (Softphone / Unified Communications)",
      "browserRequirements": "Requires JavaScript. Requires HTML5.",
      "description": "نسخه تحت وب اپلیکیشن اختصاصی نواتل؛ بدون نیاز به نصب، از طریق مرورگر برای مدیریت خط ثابت سازمانی، تماس صوتی و تصویری، CRM، پنل پیامکی، چت آنلاین سایت و فکس قابل استفاده است.",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "url": "https://app.navatel.ir/",
      "inLanguage": "fa-IR",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "IRR",
        "availability": "https://schema.org/InStock"
      }
    }
  ]
}